import { useLocalize } from 'localize-react';
import React, { useState } from 'react';
import { Card } from '../../components/card/Card';

import airplaneSvg from './airplane.svg';
import { PickupTimeline } from './PickupTimeline';
import styles from './PickupTimelineCard.module.scss';
import {
  PickupTimelineNotification,
  PickupTimelineNotificationProps,
} from './PickupTimelineNotification';
import { PickupTimelineStepProps } from './PickupTimelineItem';

export interface PickupTimelineCardProps {
  pickupTimelineSteps: PickupTimelineStepProps[];
  accommodateFlightDelaysInHours?: number;
  showFlightTrackingLabel: boolean;
  notifications?: PickupTimelineNotificationProps[];
  desktopCollapsible?: boolean;
}

export const PickupTimelineCard: React.FC<PickupTimelineCardProps> = ({
  pickupTimelineSteps,
  accommodateFlightDelaysInHours,
  showFlightTrackingLabel,
  notifications = [],
  desktopCollapsible = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { translate: t } = useLocalize();

  return (
    <div id="pickupTimeline" className={styles['pickup-timeline-card']}>
      <Card
        title={t('h_pickup_timeline_card_title')}
        collapsed={isCollapsed}
        onCollapse={() => setIsCollapsed(!isCollapsed)}
        desktopCollapsible={desktopCollapsible}
        collapsibleIcon
      >
        <>
          {showFlightTrackingLabel
          && (
          <div className={styles['with-tracking-label']}>
            <div className={styles['icon-l']}>
              <img src={airplaneSvg} alt="airplane icon" />
            </div>
            <div className="caption">{t('with_flight_tracking')}</div>
          </div>
          )}
          {notifications.map((notification) => (
            <div key={notification.title} className={styles['notification-container']}>
              <PickupTimelineNotification {...notification} />
            </div>
          ))}
          <PickupTimeline pickupTimelineSteps={pickupTimelineSteps} />
          {accommodateFlightDelaysInHours ? (
            <p className={styles['accomodate-delay']}>
              {t('p_pickup_timeline_accomodateFlightDelays', { accommodateFlightDelaysInHours })}
            </p>
          ) : null}
        </>
      </Card>
    </div>
  );
};
